import { LOGOUT } from "../constants";

export const logoutAction = () => {
  return {
    type: LOGOUT,
  };
};
